import { ResponsiveContainer, AreaChart as BaseAreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";

interface AreaChartProps {
  data: any[];
}

const AreaChart = ({ data }: AreaChartProps) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BaseAreaChart data={data} margin={{ top: 50 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis allowDecimals={false} />
        <Tooltip />
        <Area type="monotone" dataKey="count" stroke="#2cb1bc" fill="#bef8fd" />
      </BaseAreaChart>
    </ResponsiveContainer>
  );
};

export default AreaChart;
